export default __webpack_public_path__ + "static/media/01_Kom_FMH.018a9a0d.jpg";